// extracted by mini-css-extract-plugin
export default {"Fretes_Container":"fretes_Fretes_Container__Qwo+-","fretes":"fretes_fretes__FzKG1","par":"fretes_par__DLgYQ","vertical":"fretes_vertical__JrEcu"};